import { z } from 'zod/v4';

export interface ComponentSettingsDTO extends z.infer<typeof ComponentImportSettingsRuntype> {}

export const ComponentImportSettingsRuntype = z.object({
    allow_component_type_switch: z.boolean(),
    components_deletion_limit: z.number().int().min(0),
});

export const ComponentSettingsDataRuntype = z.object({
    import: ComponentImportSettingsRuntype,
});

export const ComponentSettingsRuntype = z.object({
    data: ComponentSettingsDataRuntype,
});
